import { Playground, Props } from 'docz';
import { Button } from "../../../../src/components/Button";
import * as React from 'react';
export default {
  Playground,
  Props,
  Button,
  React
};